/** get items column */
// import { TagItemTypes } from "../../../badge-and-tag/ERP";
export const columns = ()=>{
  return [
    {
      title: "รหัสสินค้า",
      key: "stcode",
      dataIndex: "stcode", 
      width:"15%",
      sorter: (a, b) => (a?.stcode || "").localeCompare(b?.stcode || ""),
    },
    {
      title: "ชื่อสินค้า",
      dataIndex: "stname",
      key: "stname",
      sorter: (a, b) => (a?.stname || "").localeCompare(b?.stname || ""),
      // width:"25%",
    },
    {
      title: "ชนิดสินค้า",
      dataIndex: "typename",
      key: "typename",
      width:"15%",
      sorter: (a, b) => (a?.typename || "").localeCompare(b?.typename || ""),
    },
  ]
};